
import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '@/components/common/organisms/PaginationButton.vue'

export type StudyData = {
  studyContentId: number
  gradeName: string
  studyName: string
  isPresenceStudied: boolean
  isSingle: boolean | null
  disableIsSingle: boolean
  periods: PeriodsData
  disablePeriods: boolean
  isScoring: boolean
  isTime: boolean | null
  disableIsTime: boolean
}

export type StudySearchQuery = {
  studyContentId?: string
  gradeId?: number
  studyName?: string
}

export type SettingData = {
  studyContentId: number
  isSingle?: boolean | null
  periods?: PeriodsData
  isTime?: boolean | null
}

export type PeriodsData = {
  startDate: string
  endDate: string
}

export type DateRangePickerData = {
  start: Date
  end: Date
} | null

export type StudyObject = {
  pagination: Pagination
  responses: StudyData[]
}

@Component
export default class StudyListApis extends Vue {
  /**
   * テスト一覧取得
   */
  protected async searchStudies(Page: number, studySearchQuery: StudySearchQuery): Promise<StudyObject> {
    const { data } = await Vue.prototype.$http.httpWithToken.get(`/v1/study_contents/search?page=${Page}`, {
      params: studySearchQuery,
    })
    return data
  }

  /**
   * 学年一覧取得
   */
  protected async loadGrades() {
    const { data } = await Vue.prototype.$http.httpWithToken.get('/v1/grades', {
      params: { onlyEnableStudy: true },
    })
    return data.map((obj: { id: number; code: string; name: string; sort_num: number }) => {
      return { value: obj.id, text: obj.name }
    })
  }

  /**
   * テスト設定登録
   */
  protected async configureStudies(settingData: SettingData[]) {
    await Vue.prototype.$http.httpWithToken.post('/v1/study_contents/configure', settingData)
  }
}
